import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewFormsComponent } from './preview-forms.component';
import { FormDateComponent } from './form-date/form-date.component';
import { FormTimeComponent } from './form-time/form-time.component';
import { FormShortComponent } from './form-short/form-short.component';
import { FormLongComponent } from './form-long/form-long.component';
import { FormScoreComponent } from './form-score/form-score.component';
import { FormSignleComponent } from './form-signle/form-signle.component';
import { FormMultipleComponent } from './form-multiple/form-multiple.component';
import { FormFileuploadComponent } from './form-fileupload/form-fileupload.component';
import { FormMatrixComponent } from './form-matrix/form-matrix.component';
import { FormDropdownComponent } from './form-dropdown/form-dropdown.component';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { TextareaModule } from 'primeng/textarea';
import { ButtonModule } from 'primeng/button';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { DatePickerModule } from 'primeng/datepicker';
import { ValidateItemsModule } from '../validate-items/validate-items.module';
import { LoadingComponent } from '../loading/loading.component';



@NgModule({
  declarations: [
    PreviewFormsComponent,
    FormDateComponent,
    FormTimeComponent,
    FormShortComponent,
    FormLongComponent,
    FormScoreComponent,
    FormSignleComponent,
    FormMultipleComponent,
    FormFileuploadComponent,
    FormMatrixComponent,
    FormDropdownComponent,
  ],
  imports: [
    CommonModule,
    InputTextModule,
    TextareaModule,
    ButtonModule,
    RadioButtonModule,
    FormsModule,
    ReactiveFormsModule,
    CheckboxModule,
    DatePickerModule,
    SelectModule,
    ValidateItemsModule,
    LoadingComponent
  ],
  exports: [
    PreviewFormsComponent
  ]
})
export class PreviewFormsModule { }
